import { handleError } from "../../../../utils/helpers";
import { baseApi } from "../../../api";
import { AdminLoginPayload, AdminLoginResponse } from "./auth.types";

export const authApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    adminLogin: builder.mutation<AdminLoginResponse, AdminLoginPayload>({
      query: (payload) => {
        return {
          url: "admin/login",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const { useAdminLoginMutation } = authApi;
